module.exports = __webpack_public_path__ + "img/news-1.b9f460cb.jpg";